import * as Types from '../../constants/actionTypes';
const defaultState = {
  list: []
}
export default (state = defaultState, action) => {

  switch (action.type) {

    case Types.LIST_CURRENCY:
      return {
        ...state,
        list: action.data,
      }
    default:
      return state;
  }
};
